// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// px2rem 自适应
import './utils/flexible.js'
// import 'lib-flexible'
import viewUi from 'view-design';
import 'view-design/dist/styles/iview.css';
import elementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import animated from 'animate.css'
import {WOW} from 'wowjs'
import axios from './assets/js/fetch'
import Carousel3d from 'vue-carousel-3d';

Vue.prototype.$axios = axios
Vue.use(Carousel3d)
Vue.use(animated)
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 0, // default
  mobile: true, // default
  live: true, // default
  callback: function (box) {
    console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
  }
})
Vue.use(viewUi)
Vue.use(elementUi)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js